import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { doc, getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"
import { getAuth, GoogleAuthProvider } from "firebase/auth"

const firebaseConfig = {
    // apiKey: process.env.API_KEY,
    // authDomain: process.env.AUTH_DOMAIN,
    // databaseURL: process.env.DATABASE_URL,
    // projectId: process.env.PROJECT_ID,
    // storageBucket: process.env.STORAGE_BUCKET,
    // messagingSenderId: process.env.MESSAGING_SENDER_ID,
    // appId: process.env.APP_ID,
    // measurementId: process.env.MEASUREMENT_ID
    apiKey: "AIzaSyA3slGsvLlCsEhroy6WSL7bvMINbg7Otlg",
    authDomain: "checsclub.firebaseapp.com",
    projectId: "checsclub",
    storageBucket: "checsclub.appspot.com",
    messagingSenderId: "906563078993",
    appId: "1:906563078993:web:3bb1531f80f5fb2060a170",
    measurementId: "G-5BZ1MYCPTF"
  }

const app = initializeApp(firebaseConfig)

export const analytics = getAnalytics(app)

export const db = getFirestore(app)
export const adminDbPath = "admin"
export const masterInfoDocRef = doc(db, "admin", "masterInfo")
export const usersDbPath = "users"
export const imageDataDbPath = "image-data"

export const storage = getStorage(app)
export const imageStoragePath = "images/"

export const auth = getAuth(app)
export const authProvider = new GoogleAuthProvider()